require('./_report-sku');
require('../../search/_submit');

jQuery(document).ready(() => {
  let currentBtn = null;

  localStorage.setItem('lastSelectedReprint', idReprint);
  localStorage.setItem('lastSelectedWeek', $('select[name="reportweeks"]').val());

  $('.select-hymnal').select2({
    placeholder: 'Hymnals / Resources'
  });

  $('.select-reportForWeek').select2({
    placeholder: 'Select Week',
    minimumResultsForSearch: Infinity
  });

  if ($('#reportModal .select-licenseType').length) {
    $('#reportModal .select-reportForWeek').select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity,
      disabled: true
    });
  } else {
    $('#reportModal .select-reportForWeek').select2({
      placeholder: 'Select Week',
      minimumResultsForSearch: Infinity
    });
  }

  $('.select-licenseType').select2({
    placeholder: 'Select License Type',
    minimumResultsForSearch: Infinity
  });

  $('#available-lists').select2({
    placeholder: 'Select a list to report from',
    minimumResultsForSearch: Infinity
  });

  $('.select-reprint').select2({
    placeholder: 'Select title to report',
    minimumResultsForSearch: Infinity
  });

  $('.select-template').select2({
    placeholder: 'Select List',
    minimumResultsForSearch: Infinity
  });

  $('#num_services').select2({
    minimumResultsForSearch: Infinity
  });


  $('.select-graphic-source').combobox({
    placeholder: 'Graphic usage',
    class: 'select-graphic_usage'
  });

  $('.time-report').select2({
    placeholder: 'Select Week',
    minimumResultsForSearch: Infinity
  });

  $('#btnEditCancel').click((e) => {
    $('#reportModal').modal('hide');

    e.preventDefault();
  });

  $('.select-licenseType').on('select2:select', function (e) {
    const id = $(this).find('option:selected').val();

    $('.time-report').select2('val', '');
    $('.time-report').select2({
      disabled: true,
      minimumResultsForSearch: Infinity,
      placeholder: 'loading...'
    });

    $.post(loadWeeksUrl, {
      id
    }, (data) => {
      $('.time-report option').remove();

      $.each(data.weeks, (i, item) => {
        $('.time-report').append($('<option>', {
          value: i,
          text: item
        }));
      });

      $('.time-report').select2({
        disabled: false,
        minimumResultsForSearch: Infinity
      });
    }, 'json');
  });

  $('select[name="reporttype"]').on('change', function () {
    const type = $(this).val();

    $('#save-error').hide();
    $('#save-successfull').hide();

    $.post(saveReportUrl, {
      id: idRegistration,
      type
    }, (data, b) => {
      $('#save-report').button('reset');

      if (data.isError == 1) {
        $('#save-error .save-error-message').html(data.msgError);
        $('#save-error').show();
      } else {
        $('#save-successfull').show();
      }
    });
  });

  $('#reportFormEdit').submit((e) => {
    e.preventDefault();
  });

  $('#submit-edit-form').click(() => {
    $('#reportModalAlert').hide();

    const graphicUsage = $('.select-graphic_usage input').val();
    const type = $('select[name="num_services"]').val();
    const weeks = $('select[name="weeks"]').val();

    const form = $('#addToListForm');
    dataArr = form.serializeArray();

    $('#reportModal').find('button').button('loading');

    const postData = {
      idTitle: currentBtn.data('id-title'),
      idHymn: currentBtn.data('id-hymn'),
      idRegistration: currentBtn.data('id-registration'),
      idSong: currentBtn.data('id-song'),
      graphicUsage,
      weeks,
      type
    };

    if (country !== 'AU' && country !== 'NZ') delete postData.graphicUsage;

    $.post(saveReportEdit, postData, (data) => {
      $('#reportModal').find('button').button('reset');

      if (data.isError == 1) {
        $('#reportModalAlert').html(data.msgError);
        $('#reportModalAlert').show();
      } else {
        $('#reportModal').modal('hide');

        if ($('.select-reportForWeek').val() !== weeks) {
          currentBtn.parent().parent().parent().fadeOut(300, function () {
            $(this).remove();
          });
        } else {
          currentBtn.parent().parent().find('.info_services').html(type + (type > 1 ? ' Services' : ' Service'));
          currentBtn.parent().parent().find('.info_services_historical').html(`Services: ${type}`);
          currentBtn.data('graphic-source', graphicUsage);
          currentBtn.data('num-services', type);

          if (country !== 'AU' && country !== 'NZ') return;

          let source = currentBtn.parent().parent().find('.info_graphic_source');
          if (graphicUsage) {
            if (!source.length) {
              source = $('<p>');
              source.addClass('info_graphic_source');

              currentBtn.parent().parent().find('.info_copyright').after(source);
            }

            source.html(`Source: ${graphicUsage}`);
          } else {
            source.remove();
          }
        }
      }
    });
  });

  $('#save-successfull button.close, #save-error button.close').click(function () {
    $(this).parent().hide();
  });

  $('#addToListForm').submit((e) => {
    e.preventDefault();
  });

  $('#submit-view').click(() => {
    $('#addToListAlert').hide();

    const form = $('#addToListForm');
    const dataArr = form.serializeArray();

    $('#addToListModal').find('button').button('loading');

    $.post(saveAsListUrl, {
      titles,
      dataArr
    }, (data) => {
      $('#addToListModal').find('button').button('reset');

      if (data.isError == 1) {
        $('#addToListAlert').html(data.msgError);
        $('#addToListAlert').show();
      } else {
        /* redirect to url from response */
        window.location.href = `${redirectToListUrl}?id=${data.idList}`;
      }
    });
  });

  $('#submit-continue').click(() => {
    $('#addToListAlert').hide();

    const form = $('#addToListForm');
    const dataArr = form.serializeArray();

    $('#addToListModal').find('button').button('loading');

    $.post(saveAsListUrl, {
      titles,
      dataArr
    }, (data) => {
      $('#addToListModal').find('button').button('reset');

      if (data.isError == 1) {
        $('#addToListAlert').html(data.msgError);
        $('#addToListAlert').show();
      } else {
        alert('List has been saved successfully.');
        $('#addToListModal').modal('hide');
      }
    });
  });

  $('#addToListModal').on('show.bs.modal', (e) => {
    $('#addToListAlert').hide();

    $('.select-template').select2('val', '');
    $('#addToListModal input[name="list-name"]').val('');
  });

  $('#QrtLists').submit(function (e) {
    const form = $(this);
    const dataArr = form.serializeArray();

    form.find('button').button('loading');

    $.post(reportFromListUrl, {
      dataArr
    }, (data) => {
      form.find('button').button('reset');

      if (data.isError == 1) {
        alert(data.msgError);
      } else {
        location.reload();
      }
    }, 'json');

    e.preventDefault();
  });

  $('.add-title-to-report').click(function (e) {
    const btnRfc = $(this);
    const idTitle = $(this).parent().parent().find('select')
        .val();

    btnRfc.button('loading');

    $.post(reportSingleTitleUrl, {
      idRegistration,
      idTitle
    }, (data) => {
      btnRfc.button('reset');

      if (data.isError == 1) {
        alert(data.msgError);
      } else {
        location.reload();
      }
    }, 'json');

    e.preventDefault();
  });

  $('#removeTitleModal').on('show.bs.modal', (e) => {
    currentBtn = $(e.relatedTarget);
  });

  $('#btnRemoveItem').click(() => {
    $('#removeTitleModal').find('button').button('loading');

    $.post(removeTitleUrl, {
      idTitle: currentBtn.data('id-title'),
      idHymn: currentBtn.data('id-hymn'),
      idRegistration: currentBtn.data('id-registration')
    }, (data) => {
      $('#removeTitleModal').find('button').button('reset');

      if (data.isError == 1) {
        alert(data.msgError);
      } else {
        currentBtn.parent().parent().parent().fadeOut(300, function () {
          $(this).remove();
        });

        currentBtn = null;

        $('#removeTitleModal').modal('hide');
      }
    }, 'json');
  });

  $('.panel-report .select-reportForWeek').change(function () {
    const value = $(this).val();
    window.location.href = redirectReportsManage + value;
  });

  $('#process-download, .download-single-song').click(function (e) {
    document.cookie = 'fileDownload=; Max-Age=0';
    const urlFile = $(this).data('url');

    if (urlFile != null) {
      $('#downloadAllModal #navigation').hide();
      $('#downloadAllModal #loading').show();
      $('#downloadAllModal').modal('show');

      $.get(urlFile, (data) => {
        if (data.isError === 1) {
          $('#downloadAllModal').modal('hide');
          toastr.error(data.msgError, 'Error');
        } else {
          $('#downloadAllModal #navigation').show();
          $('#downloadAllModal #loading').hide();
        }
      }, 'json');
    }

    e.preventDefault();
  });

  $('#save-report').click(function (e) {
    $(this).button('loading');

    toastr.success('Report saved successfully', 'Success');
    $(this).button('reset');
  });

  $('#reportModal').on('show.bs.modal', (e) => {
    currentBtn = $(e.relatedTarget);

    $('#r-title').html(`"${currentBtn.data('title')}"`);
    $('#r-subtitle').html(currentBtn.data('subtitle'));
    $('#r-detail').html(currentBtn.data('detail'));
    $('#r-tune').html(currentBtn.data('tune'));
    $('.select-graphic_usage input').val(currentBtn.data('graphic-source'));
    $('select[name="num_services"]').val(currentBtn.data('num-services')).trigger('change');
    $('select[name="weeks"]').val($('.select-reportForWeek').val()).trigger('change');
  });

  $('#editPendingItemModal').on('show.bs.modal', (e) => {
    currentBtn = $(e.relatedTarget);

    $('#editPendingItemModal #p-title').html(`"${currentBtn.data('title')}"`);
    $('#editPendingItemModal select[name="p_num_services"]').val(currentBtn.data('num-services')).trigger('change');
  });

  $('#submitEditPendingForm').click(() => {
    $('#editPendingItemModalAlert').hide();

    const numServices = $('select[name="p_num_services"]').val();

    $('#editPendingItemModal').find('button').button('loading');

    $.post(savePendingTrackUrl, {
      id: currentBtn.data('id-submission'),
      numServices
    }, (data) => {
      $('#editPendingItemModal').find('button').button('reset');

      if (data.isError == 1) {
        $('#editPendingItemModalAlert').html(data.msgError);
        $('#editPendingItemModalAlert').show();
      } else {
        $('#editPendingItemModal').modal('hide');

        currentBtn.parent().parent().find('.info_services').html(data.numServices + (data.numServices > 1 ? ' Services' : ' Service'));
      }
    });
  });

  $('#removePendingSongModal').on('show.bs.modal', (e) => {
    currentBtn = $(e.relatedTarget);
  });

  $('#btnRemovePendingSong').click(() => {
    $('#removePendingSongModal').find('button').button('loading');

    $.post(removePendingSongUrl, {
      id: currentBtn.data('id-submission')
    }, (data) => {
      $('#removePendingSongModal').find('button').button('reset');

      if (data.isError == 1) {
        alert(data.msgError);
      } else {
        currentBtn.parent().parent().parent().fadeOut(300, function () {
          const parent = $(this).parent();

          $(this).remove();

          if (parent.find('.search-music').length == 0) {
            parent.html('<i>No pending tracks to display</i>');
          }
        });

        currentBtn = null;

        $('#removePendingSongModal').modal('hide');
      }
    }, 'json');
  });

  $('#removeAllSongs').click(function (e) {
    const btn = $(this);
    const id = btn.data('id');
    btn.button('loading');

    bootbox.confirm({
      title: 'Delete All Reported Songs',
      message: 'Are you sure you want to delete all reported songs from this week?',
      buttons: {
        cancel: {
          label: '<i class="fa fa-times"></i> No',
          className: 'btn-default btn-dark'
        },
        confirm: {
          label: '<i class="fa fa-check"></i> Yes',
          className: 'btn-green btn btn-space'
        }
      },
      callback(result) {
        if (result) {
          $.post(removeAllReportedSongsUrl, {
            id
          }, (data, b) => {
            btn.button('reset');

            if (data.isError == 1) {
              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success('Songs has been removed.', 'Success');
              location.reload();
            }
          });
        } else {
          btn.button('reset');
        }
      }
    });

    e.preventDefault();
  });
});
